var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9374 2.96875H4.06244C3.07868 2.96875 2.28119 3.76624 2.28119 4.75V15.4375C2.28119 16.4213 3.07868 17.2188 4.06244 17.2188H15.9374C16.9212 17.2188 17.7187 16.4213 17.7187 15.4375V4.75C17.7187 3.76624 16.9212 2.96875 15.9374 2.96875Z",
    stroke: "#6D7B75",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3555 8.60937C12.3555 9.09047 11.9655 9.48047 11.4844 9.48047C11.0033 9.48047 10.6133 9.09047 10.6133 8.60937C10.6133 8.12828 11.0033 7.73828 11.4844 7.73828C11.9655 7.73828 12.3555 8.12828 12.3555 8.60937Z",
    fill: "#6D7B75",
    stroke: "#6D7B75",
    strokeWidth: 0.0390625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 9.5C14.945 9.5 15.3437 9.10125 15.3437 8.60937C15.3437 8.1175 14.945 7.71875 14.4531 7.71875C13.9612 7.71875 13.5625 8.1175 13.5625 8.60937C13.5625 9.10125 13.9612 9.5 14.4531 9.5Z",
    fill: "#6D7B75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 12.4687C11.9763 12.4687 12.375 12.07 12.375 11.5781C12.375 11.0862 11.9763 10.6875 11.4844 10.6875C10.9925 10.6875 10.5938 11.0862 10.5938 11.5781C10.5938 12.07 10.9925 12.4687 11.4844 12.4687Z",
    fill: "#6D7B75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 12.4687C14.945 12.4687 15.3437 12.07 15.3437 11.5781C15.3437 11.0862 14.945 10.6875 14.4531 10.6875C13.9612 10.6875 13.5625 11.0862 13.5625 11.5781C13.5625 12.07 13.9612 12.4687 14.4531 12.4687Z",
    fill: "#6D7B75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54688 12.4687C6.03875 12.4687 6.4375 12.07 6.4375 11.5781C6.4375 11.0862 6.03875 10.6875 5.54688 10.6875C5.055 10.6875 4.65625 11.0862 4.65625 11.5781C4.65625 12.07 5.055 12.4687 5.54688 12.4687Z",
    fill: "#6D7B75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51563 12.4687C9.0075 12.4687 9.40625 12.07 9.40625 11.5781C9.40625 11.0862 9.0075 10.6875 8.51563 10.6875C8.02375 10.6875 7.625 11.0862 7.625 11.5781C7.625 12.07 8.02375 12.4687 8.51563 12.4687Z",
    fill: "#6D7B75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54688 15.4375C6.03875 15.4375 6.4375 15.0388 6.4375 14.5469C6.4375 14.055 6.03875 13.6562 5.54688 13.6562C5.055 13.6562 4.65625 14.055 4.65625 14.5469C4.65625 15.0388 5.055 15.4375 5.54688 15.4375Z",
    fill: "#6D7B75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51563 15.4375C9.0075 15.4375 9.40625 15.0388 9.40625 14.5469C9.40625 14.055 9.0075 13.6562 8.51563 13.6562C8.02375 13.6562 7.625 14.055 7.625 14.5469C7.625 15.0388 8.02375 15.4375 8.51563 15.4375Z",
    fill: "#6D7B75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 15.4375C11.9763 15.4375 12.375 15.0388 12.375 14.5469C12.375 14.055 11.9763 13.6562 11.4844 13.6562C10.9925 13.6562 10.5938 14.055 10.5938 14.5469C10.5938 15.0388 10.9925 15.4375 11.4844 15.4375Z",
    fill: "#6D7B75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24994 1.78125V2.96875M14.7499 1.78125V2.96875",
    stroke: "#6D7B75",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7187 5.9375H2.28119",
    stroke: "#6D7B75",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCalendar);
export default __webpack_public_path__ + "static/media/grayCalendar.8a6e5d5e04d7b7cdc1154408c1aa4427.svg";
export { ForwardRef as ReactComponent };